<template>
  <div>
    <div v-if="loading" class="row" key="loading">
      <div class="col-6 offset-3">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div v-else class="row mt-4">
      <div class="col-12">
        <div class="d-inline-flex flex-wrap alert alert-secondary mt-2">
          <div
            v-bind:class="{
              'border border-info rounded p-2': selectedLetter === l,
              'p-2': selectedLetter !== l,
            }"
            v-for="l in letters"
            v-bind:key="l"
          >
            <a
              @click="loadStreets(l)"
              class="alert-link"
              href="javascript:void()"
            >
              <h3 style="margin-bottom: 0px">{{ l }}</h3>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-sm-12 offset-sm-0 col-11 offset-1">
        <transition name="slide-fade" mode="out-in">
          <div v-if="streets.length" class="ml-4">
            <div v-for="s in streets" v-bind:key="s.fields.slug">
              <p>
                <a :href="`/ulice/${s.fields.slug}`">
                  <h4>{{ s.fields.name }}</h4>
                </a>
              </p>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import {truncate} from '../common.js';

export default {
  name: "ArchitectsSelector",
  data: function () {
    return {
      selectedLetter: "A",
      letters: [],
      streets: [],
      loading: false,
    };
  },
  filters: {
    truncate: truncate,
  },
  methods: {
    loadStreets: function (letter) {
      this.streets = [];
      sessionStorage.setItem("streetLetter", letter);
      this.selectedLetter = letter;
      Axios.get("/api/streets/index/" + this.selectedLetter).then(
        (response) => (this.streets = response.data)
      );
    },
  },
  beforeMount: async function () {
    let letter = sessionStorage.getItem("streetLetter");
    if (!letter) {
      letter = "A";
    }
    let letters = sessionStorage.getItem("streetLetters");
    if (!letters) {
      this.loading = true;
      let response = await Axios.get("/api/streets/letters/");
      this.loading = false;
      this.letters = response.data;
      sessionStorage.setItem("streetLetters", JSON.stringify(this.letters));
    } else {
      this.letters = JSON.parse(letters);
    }
    this.loadStreets(letter);
  },
};
</script>
